import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { getFormValues, change } from 'redux-form';
import BaseImageInput from '../../inputs/ImageInput';
import ThumbnailImageField from '../../fields/ThumbnailImageField';

class ImageInput extends React.Component {
  onChange = (files) => {
    const { source, onlyUrl, multiple } = this.props;
    const newFiles = (files || []).map((o) => {
      // It may be a recently uploaded file
      if (o.rawFile) {
        return {
          ...o,
          source,
          onlyUrl,
          asArray: multiple,
        };
      // Or a previously uppload file in which case return the src
      } else if (o.src) {
        return o.src;
      }
      // Or it is the src directly
      return o;
    });
    const nextFiles = [...newFiles];
    this.props.change('record-form', source, nextFiles);
  }

  render() {
    const {
      multiple, record, source,
    } = this.props;
    const value = (get(record, source) || []).map((data) => {
      // Do this transformation so that the thumbnail can be shown for
      // previously uploaded images
      if (typeof data === 'string') {
        return { src: data };
      }
      return data;
    });
    return (
      <BaseImageInput
        input={{
          value,
          onChange: this.onChange,
        }}
        accept="image/*"
        multiple={multiple}
      >
        <ThumbnailImageField source="src" />
      </BaseImageInput>
    );
  }
}

ImageInput.propTypes = {
  multiple: PropTypes.bool,
  // This is the path to the original obj were the src will be received
  source: PropTypes.string.isRequired,
  // If true means that the source path will contain imagerepresentations
  // in the form of a srting (url)
  onlyUrl: PropTypes.bool,
};

const selector = getFormValues('record-form');

export default connect(
  (state) => ({
    record: selector(state),
  }),
  { change }
)(ImageInput);
